export const getTimestamp = (timestamp, timezone, ambiguous) => (
  (new Date(timestamp)).toLocaleString('en', { timeZone: timezone, timeZoneName: 'short' })
  + (ambiguous ? ' (Uncertain)' : '')
);

export const getDate = (date) => {
  if (!date) return ''
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
};

export const getTime = (date) => {
  if (!date) return ''
  const hours = date.getHours();
  const minutes = date.getMinutes();
  return (hours < 10 ? '0' + hours : hours) + ':' + (minutes < 10 ? '0' + minutes : minutes);
};

export const getDateTime = ({ date, time }) => {
  const [year, month, day] = date.split('-');
  const [hour, minute] = time.split(':');
  return new Date(year, Number(month) - 1, day, hour, minute);
};

// update 220822 LiveCharts
export const getSeconds = (date) => {
  if (!date) return ''
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  return (hours < 10 ? '0' + hours : hours) + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
};